/* eslint-disable no-unused-vars */
import {useState, useEffect,useRef, forwardRef} from 'react';
import {NavLink} from 'react-router-dom';
import './Navbar.css';
//import { ReactComponent as Hamburger } from '../../assets/icons/hamburger.svg'
//import { ReactComponent as Brand } from '../../assets/icons/logo.svg'

import SearchInput from '../../components/SearchInput';
import SearchIcon from "@material-ui/icons/Search";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";

import {SidebarNav,customRouterLink} from '../../layouts/Main/components/Sidebar/components'
import MenuItem from './MenuItem';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  TextField,
  Typography,
  makeStyles,
  Grid,
  colors
} from '@material-ui/core';
import { AppBar, Toolbar, Badge, Hidden } from '@material-ui/core';

import logo from '../../components/logo.jpeg'

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false)

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar)
  }

  //Setting the Visibility of the search button to true or false
  const[visible, setVisible] =useState(true);
  const[width, setWidth] = useState(window.innerHeight);

  const handleVisibility=()=>{
    setVisible(prev => !prev);
  };

  const handleWidth =()=>{
    setWidth(window.innerWidth);
  };

  useEffect(()=>{
    console.log(visible);
    window.addEventListener("resize", handleWidth);
    width > 600 ? setVisible(false): setVisible(true);
    return()=>{
        window.removeEventListener("resize", handleWidth);
    };
    //eslint-disable-next-line
  },[width]);

  return (
    
    <Toolbar className="navbar">
      <img
            alt="Logo"
            src="/images/logos/logo.jpeg"
            height={30}
      />
      <div className={`nav-elements  ${showNavbar && 'active'}`}>
      {MenuItem.slice(0,5).map((page) => (
        <ul key={page.title}>
          <li>
            <NavLink to={page.to}>{page.title}</NavLink>
          </li>
        </ul>
      ))}
        <div>
       {/*<SidebarNav
        pages={pages} 
        ref={ref}
        to={pages.to}  
        />*/}
  </div>
</div>    
    </Toolbar>


            
          
    
  )
}

export default Navbar